import { LegalPage } from './_LegalPage';

export function Support() {
  return <LegalPage docKey="support" />;
}
